import './Header.css';

function Header() {
    return (
        <header>
            <h1>
                Accio Cards!
            </h1>
            <h2>
                Harry Potter Memory Game
            </h2>
            <h3>
                Yer a playa, Harry!
            </h3>
        </header>
    );
}

export default Header;